import styled from '@emotion/styled';

export const VisualSearchLayout = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.custom['gray-80']};

  @media (max-width: 1024px) {
    flex-direction: column;
    overflow-y: auto;
    height: auto;
  }
`;

export const VisualSearchSidebar = styled.div`
  flex: 0 0 14em;
  padding: 44px 24px 0;
  overflow-y: auto;

  @media (max-width: 1024px) {
    flex: unset;
    padding: 16px 24px;
    overflow-y: unset;
    border-bottom: 1px solid ${({ theme }) => theme.palette.custom['gray-60']};
  }
`;

export const VisualSearchContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;

  @media (max-width: 1024px) {
    overflow: unset;
  }
`;
